<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		<!--neirong-->
		<div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner02.png" alt="内页banner">
				<div class="nybt">
					<h3>内页banner</h3>
				</div>
			</div>
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;关于我们
					&gt;
					{{ title }}
				</div>
			</div>

			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">


					<!-- * 右侧 * -->
					<div class="page-wrap-right">

						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
								<ul class="xypg-left-nav">
									<li :class="item.categoryCode == type ? 'clicked' : ''" v-for="item in actList">
										<a href="javascript:void(0)"
											@click="changeData(item.categoryCode, item.categoryName)">
											{{ item.categoryName }}</a>
										<div class="first-nav-btn"></div>
									</li>
								</ul>
							</div>
						</div>
						<div class="xypg-right-content">
							<div class="newwh">
							<div v-if="title == '公司介绍' || title == '企业文化'">
								<!-- <img :src="detail.image" v-if="detail.image"> -->
								<div>
									<div v-html="detail.cmsArticleData ? detail.cmsArticleData.content : ''"
										class="company-con"></div>
								</div>
							</div>
							<div v-if="title == '发展历程'">
								<!-- <div>
									<div class="fazhan_t">恒润集团发展大事记</div>
									<div class="fazhan_t2">
										<p>2001年成立至今</p>
									</div>
									<ul id="licheng">
										<li :class="index%2 != 1?'li1':'li2'" v-for="(item,index) in list">
											<div class="yuan"><img  src="@/assets/images/yuan.png"/></div>
											<div :class="index%2 != 1?'licheng_txt fr':'licheng_txt fl'">
												<div class="licheng_t1"><strong>{{item.title}}</strong></div>
												
												<p style="padding-top: 20px;"><textarea style="width: 100%; outline: none; height: 280px; border: none;">{{item.describtion}}</textarea></p>
											</div>
											<div class="clear"></div>
										</li>
										
										<div class="clear"></div>
									</ul>
								</div> -->

								<div class="m-timeline-wrap">
									<div class="m-time-dot">
										<div :class="['m-dot-box', { 'active': active === item.title }]"
											@click="onClickYear(item)" v-for="(item, index) in list" :key="index">
											<p class="u-year">{{ item.title }}</p>
											<div class="m-dot">
												<div class="u-dot"></div>
											</div>
										</div>
									</div>
								</div>
								<div style="white-space: pre-line;">{{selDescribtion}}</div>

							</div>
							</div>
							<div v-if="title =='荣誉资质'">
								<div class="tab-box">
									<el-tabs v-model="activeName" @tab-click="handleClick">
										<el-tab-pane label="企业荣誉" name="300006"></el-tab-pane>
										<el-tab-pane label="企业资质" name="300007"></el-tab-pane>
									</el-tabs>
								</div>
								<ul class="xypg-product-list2 clearfix">
									<li v-for="item in list">
										<a href="javascript:void(0)" class="img"><img :src="item.image" /></a>
										<h3><a href="javascript:void(0)">{{ item.title }}</a></h3>
									</li>
								</ul>
								<div class="xypg-pagination">
									<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
										:current-page="pageNum" :page-sizes="[6, 10, 20, 50, 100]" :page-size="pageSize"
										layout="total, sizes, prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</div>


				</div>
			</div>

			<Footer />
		</div>



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		articleDetail,
		categorysortPage,
		articleList
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pageNum: 1,
				pageCount: 0,
				actList: [],
				type: '200003',
				title: '公司介绍',
				activeName: '300006',
				total: 0,
				list: [],
				pageNum: 1,
				totalPage: 0,
				pageSize: 10,
				active: '',
				selDescribtion: ''
			}
		},

		mounted() {

			this.type = this.$route.query.type
			this.title = this.$route.query.title
			this.getCategorysortPage()
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.getNewDetail();
			} else {
				if (this.title == '公司介绍' || this.title == '企业文化') {
					this.pageSize = 1
					this.getCaseList()
				} else if (this.title == '荣誉资质') {
					this.activeName = '300006'
					this.pageSize = 6
					this.getData()
				} else {
					this.pageSize = 99
					this.getCaseList()
				}
			}


		},

		methods: {
			onClickYear(item) {
				if (this.active !== item.title) {
					this.active = item.title
					this.selDescribtion = item.describtion
				}
			},

			handleClick() {
				this.pageNum = 1
				this.getData()
			},
			// 页码容量变化
			handleSizeChange(pageSize) {
				this.pageNum = 1
				this.pageSize = pageSize
				this.getData()
			},

			// 当前页码变化
			handleCurrentChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},

			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					status: 1,
					categoryCode: this.activeName
				}
				articleList(par).then(res => {
					this.list = res.rows;
					this.total = res.total

				});
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						if (item.categoryName == '关于恒润') {
							this.actList = item.children
							this.actList.sort((a, b) => a.orderNum - b.orderNum);
						}
					})

				});
			},
			changeData(id, title) {
				let url = '/companyInfo?type=' + id + '&title=' + title
				this.$router.push(url)
				this.$router.go(0)
			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},
			getCaseList() {
				articleList({
					pageNum: 1,
					pageSize: this.pageSize,
					status: 1,
					categoryCode: this.type,
				}).then(res => {
					this.list = res.rows;
					this.total = res.total
					if (this.pageSize == 1) {
						this.id = res.rows[0].id
						this.getNewDetail()
					}
					this.active = res.rows[0].title
					this.selDescribtion = res.rows[0].describtion
				});
			},

			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
						let cmsArticleData = this.detail.cmsArticleData
						if (cmsArticleData && cmsArticleData.content) {
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g,
								'<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}


				});
			},



		}
	}
</script>

<style scoped>
	.newwh{width: 1200px; margin: 0 auto; }
	
	@media screen and (max-width: 1100px) {
		.wh{width: 94%; }}
	.company-con {
		text-indent: 2em;
		line-height: 2.5;
	}

	.company-con p {
		text-indent: 2em;
	}

	.tab-box {
		margin: auto;
		width: fit-content;
	}

	.tab-box>>>.el-tabs__item.is-active {
		color: #0070b0 !important;
	}

	.tab-box>>>.el-tabs__item:hover {
		color: #0070b0 !important;
	}

	.tab-box>>>.el-tabs__active-bar {
		background-color: #0070b0 !important;
	}

	.fazhan_t {
		font-size: 18px;
		color: #666;
		text-align: center;
		width: 200px;
		margin-top: 20px;
		margin-right: auto;
		margin-bottom: 0px;
		margin-left: auto;
		padding-top: 2px;
		padding-right: 0px;
		padding-bottom: 2px;
		padding-left: 0px;
		border: 0px solid #ccc;
		font-weight: bold;
		line-height: 40px;
	}

	.fazhan_t2 {
		text-align: center;
		font-size: 12px;
		color: #666;
		line-height: 30px;
		margin-top: 0px;
	}

	.licheng_t1 {
		color: #333;
		font-size: 16px;
	}

	.licheng_t1 strong {
		font-size: 20px;
		color: #333;
	}

	.licheng_t2 {
		color: #333;
		font-size: 14px;
	}

	.licheng_t2 strong {
		font-size: 16px;
		color: #333;
	}

	.clear {
		clear: both;
	}

	.fl {
		float: left;
		text-align: left;
	}

	.fr {
		float: right;
		text-align: right;
	}

	ul#licheng {
		background-image: url('../../assets/images/line3.png');
		background-repeat: repeat-y;
		margin-top: 30px;
		margin-right: auto;
		margin-bottom: 0px;
		margin-left: auto;
		padding-top: 20px;
		padding-right: 0px;
		padding-bottom: 20px;
		padding-left: 0px;
		background-position: center center;
	}

	ul#licheng li {

		width: 50.01%;

		padding: 0% 4% 0% 4%;
		position: relative;
	}

	.li1 .yuan {
		position: absolute;
		right: -9px;
	}

	.li2 .yuan {
		position: absolute;
		left: -9px;
	}

	.li1 {

		float: left;
	}

	.li2 {

		float: right;
	}

	.licheng_img {
		width: 28%;
	}

	.licheng_img img {
		border-radius: 50%;
		border: 2px solid #118785;
		margin-top: 10%;
		width: 100%;
	}

	.licheng_txt {
		font-size: 14px;
		color: #666666;
		width: 82%;
	}
</style>
<style scoped>
	.m-timeline-wrap {
		margin: 150px auto;
		height: 3px;
		background: #8dc6f5;
		margin-bottom: 50px;
	}

	.m-timeline-wrap .m-time-dot {
		display: flex;
		justify-content: space-around;
	}

	.m-timeline-wrap .m-time-dot .m-dot-box {
		cursor: pointer;
		text-align: center;
		transform: translateY(calc(-100% + 10px));
	}

	.m-timeline-wrap .m-time-dot .m-dot-box .u-year {
		font-size: 18px;
		font-weight: 500;
		color: #333;
		transform: translateY(-8px);
		transition: all 0.3s ease;
	}

	.m-timeline-wrap .m-time-dot .m-dot-box .m-dot {
		margin: 0 auto;
		width: 14px;
		height: 14px;
		background: #8dc6f5;
		border-radius: 50%;
		transition: all 0.3s ease;
	}

	.m-timeline-wrap .m-time-dot .m-dot-box .m-dot .u-dot {
		width: 14px;
		height: 14px;
		background: #8dc6f5;
		border-radius: 50%;
		transition: all 0.3s ease;
	}

	.m-timeline-wrap .m-time-dot .m-dot-box:hover .u-year {
		color: #1890FF;
	}

	.m-timeline-wrap .m-time-dot .m-dot-box:hover .m-dot .u-dot {
		background: #1890FF;
	}

	.m-timeline-wrap .m-time-dot .m-dot-box.active .u-year {
		transform: scale(1.5) translateY(-18px);
		color: #1890FF;
	}

	.m-timeline-wrap .m-time-dot .m-dot-box.active .m-dot {
		transform: scale(3);
	}

	.m-timeline-wrap .m-time-dot .m-dot-box.active .m-dot .u-dot {
		transform: scale(0.67);
		background: #1890FF;
	}

	@media screen and (max-width: 640px) {
		.m-timeline-wrap .m-time-dot .m-dot-box .u-year {
			font-size: 14px;
			line-height: 20px; text-align: center;
		}

		.m-timeline-wrap .m-time-dot .m-dot-box.active .u-year {
			transform: scale(1.2) translateY(-18px);

		}

		.m-timeline-wrap {
			margin: 70px auto;
		}

		.m-timeline-wrap .m-time-dot .m-dot-box.active .m-dot {
			transform: scale(2);
		}

	}
</style>